import Vue from "vue";
import store from "../store";
import moment from "moment";
import { classifyTagIds, ensureGtagStub } from "./googleTag";

const formatDate = (date) => Vue.prototype.$formatDateApi ? Vue.prototype.$formatDateApi(date) : date;
const computeReferrer = (from) => {
  if (from && from.fullPath) {
    return window.location.origin + from.fullPath
  }

  return document && document.referrer ? document.referrer : null;
}

const generatePageViewParams = (routeData) => {
  const { to, from = null } = routeData;
  const page_location = window.location.origin + to.fullPath;
  const page_path = to.path;
  const page_title = document.title || (to.meta && to.meta.title) || '';
  const page_hostname = window.location.hostname;
  const page_referrer = computeReferrer(from);

  return {
    event: 'page_view',
    main:{ page_location, page_path, page_title, page_hostname, page_referrer },
    custom: {}
  }
}

const generateSearchRoomParams = (filter) => {
  const {
    date: { check_in, check_out },
    guest: { adult, child, infant },
    promo_code
  } = filter;

  let params = {
    check_in_date: formatDate(check_in),
    check_out_date: formatDate(check_out),
    adults: Number(adult),
    children: Number(child),
    infants: Number(infant),
    promo_code
  }

  const { base_currency_code = null } = store.getters.getMerchant
  if(base_currency_code) params.currency = base_currency_code;

  return {
    event: 'search_room',
    main: params,
    custom: {}
  };
}

const getTotalPriceFromDate = (key, dates, calTaxes = false) => {
  const { search_room_is_show_tax_fee_note: showTax = false } = store.getters.getMerchant
  let total = 0;
  let totalTaxes = 0;
  dates.forEach(date=>{
    total += date[key];
    totalTaxes += date.taxes;
  })
  if(!showTax && calTaxes) total -= totalTaxes
  return total
}

const getCommonStoreData = () => {
  const merchant = store.getters.getMerchant || {};
  const filter = store.getters.getBeFilter || {};
  const { date = {}, guest = {}, promo_code = '' } = filter;

  return {
    currency: merchant.base_currency_code,
    item_brand: merchant.name,
    check_in_date: formatDate(date.check_in),
    check_out_date: formatDate(date.check_out),
    adults: Number(guest.adult || 0),
    children: Number(guest.child || 0),
    infants: Number(guest.infant || 0),
    promo_code
  };
};

const createItemObject = (roomRate, itemBrand, quantity = 1, index = null) => {
  const { id, rate, room_type, availability, dates, name: roomNameFromList } = roomRate;

  const itemName = room_type && room_type.name ? room_type.name : roomNameFromList;
  const itemVariant = rate && rate.name ? rate.name : '';

  const item = {
    item_id: id,
    item_name: itemName,
    item_brand: itemBrand,
    item_variant: itemVariant,
    item_category: "Room",
    price: getTotalPriceFromDate('final_price', dates),
    quantity: quantity,
    stock_level: availability
  };

  if (index !== null) {
    item.index = index;
  }

  return item;
};

const craeteItemArray = () => {
  let items = [];

  const { item_brand } = getCommonStoreData();

  const roomList = store.getters.getBeCart.room_rate_details;
  roomList.forEach(room => {
    const { id: item_id, room_type: { name: item_name }, rate: { name: item_variant }, dates, availability } = room.room_rate;

    items.push({
      item_id, item_name, item_variant, item_brand,
      price: getTotalPriceFromDate('final_price', dates),
      quantity: room.qty,
      stock_level: availability,
      item_category: "Room"
    });
  })

  const additionalProduct = store.getters.getBeCartAddtService;
  additionalProduct.forEach(product => {
    const { id: item_id, name: item_name, price } = product.data;
    items.push({
      item_id, item_name, item_brand,
      price: parseInt(price),
      quantity: product.qty,
      item_category: "Additional Product"
    });
  })

  const activityProduct = store.getters.getActivityTrxProducts;
  activityProduct.forEach(product => {
    const {
      original_data: {
        id: item_id,
        name: item_name,
      },
      base_price: { source: { price_sell_final_with_tax_service: price } }
    } = product;

    items.push({
      item_id, item_name, item_brand,
      price: parseInt(price),
      quantity: product.qty,
      item_category: "Additional Product"
    });
  })

  const outletProduct = store.getters.getOutletTrxProducts;
  outletProduct.forEach(product => {
    const { product_data: { id: item_id ,name: item_name }, variants, qty } = product

    const isProductVariant = variants.length > 0

    if(isProductVariant){
      variants.forEach(variant => {
        const { id: variantId, name: item_variant, price: { price_sell_final_with_tax_service: variantPrice} } = variant.variant_data;
        items.push({
          item_id: variantId,
          item_name,
          item_brand,
          item_variant,
          price: parseInt(variantPrice),
          quantity: variant.qty,
          item_category: "Additional Product"
        });
      });
    }else{
      items.push({
        item_id, item_name, item_brand,
        price: parseInt(product.product_data.price.price_sell_final_with_tax_service),
        quantity: qty,
        item_category: "Additional Product"
      });
    }
  })

  const voucherProduct = store.getters.getVoucherOrder.cart;
  voucherProduct.forEach(group => {
    group.product.forEach(product => {

      const {
        data: { id: item_id ,name: item_name},
        is_variant: isProductVariant,
        variant_list, qty } = product

      if(isProductVariant){
        variant_list.forEach(variant => {
          const { id: variantId, name: item_variant, price: { price_sell_final_with_tax_service: variantPrice} } = variant.data;
          items.push({
            item_id: variantId,
            item_name,
            item_brand,
            item_variant,
            price: parseInt(variantPrice),
            quantity: variant.qty,
            item_category: "Additional Product"
          });
        });
      }else{
        items.push({
          item_id, item_name, item_brand,
          price: parseInt(product.data.price.price_sell_final_with_tax_service),
          quantity: qty,
          item_category: "Additional Product"
        });
      }
    });


  })

  return items;
}

const generateSearchRoomResultParams = ({params, result}) => {
  const { currency, item_brand } = getCommonStoreData();
  const { check_in_date, check_out_date, adult, child, infant, promo_code } = params;

  const customParams = {check_in_date, check_out_date, adults: Number(adult), children: Number(child), infants: Number(infant) }
  const mainParams = {
    currency,
    items: []
  };

  if (promo_code) mainParams.coupon = promo_code;

  let totalIndex = 1;
  result.forEach(room => {
    room.room_rate.forEach(roomRate => {
      const rateWithParentName = Object.assign({}, roomRate, { name: room.name });
      mainParams.items.push(
        createItemObject(rateWithParentName, item_brand, 1, totalIndex++)
      );
    });
  });

  return {
    event: 'view_item_list',
    main: mainParams,
    custom: customParams
  };
}

const generateRoomRateDetailParams = (roomRate) => {
  const { check_in_date, check_out_date, adults, children, infants, currency, item_brand, promo_code } = getCommonStoreData();
  const price = getTotalPriceFromDate('final_price', roomRate.dates);

  const customParams = {check_in_date, check_out_date, adults, children, infants }

  const mainParams = {
    value: price,
    currency,
    items: [createItemObject(roomRate, item_brand, 1)]
  };

  if (promo_code) mainParams.coupon = promo_code;
  return {
    event: 'view_item',
    main: mainParams,
    custom: customParams
  };
}

const generateAddToCartParams = ({roomRate, qty}) => {
  const { check_in_date, check_out_date, adults, children, infants, currency, item_brand, promo_code } = getCommonStoreData();
  const unitPrice = getTotalPriceFromDate('final_price', roomRate.dates);

  const customParams = {check_in_date, check_out_date, adults, children, infants }
  const mainParams = {
    value: unitPrice * qty,
    currency,
    items: [createItemObject(roomRate, item_brand, qty)]
  };

  if (promo_code) mainParams.coupon = promo_code;
  return {
    event: 'add_to_cart',
    main: mainParams,
    custom: customParams
  };
}

const generateBeginCheckoutParams = (paymentInfo = null) => {
  const { check_in_date, check_out_date, adults, children, infants, currency, item_brand, promo_code } = getCommonStoreData();

  const customParams = {check_in_date, check_out_date, adults, children, infants }

  const items = craeteItemArray()
  const totalPrice = items.reduce((sum, val) => (val.price * val.quantity) + sum, 0);

  const mainParams = {
    value: totalPrice,
    currency,
    items
  };

  if(promo_code) mainParams.coupon = promo_code;
  if(Vue.prototype.$isNotEmptyV2(paymentInfo)) mainParams.payment_type = paymentInfo
  return {
    event: 'begin_checkout',
    main: mainParams,
    custom: customParams
  };
}

const generateTransactionResultParams = (transactionDetail, eventName) => {
  const {
    order_code,
    status,
    payments: { total_payment, total_taxes },
    payment_details,
    merchant: { base_currency_code: currency, name: item_brand },
    promo_code,
    transaction_details,
    additional_service_details,
    tx_merchant_pos,
    cancellation_reason = "",
    created_at
  } = Vue.prototype.$deepCopy(transactionDetail);

  const items = [];

  const rooms = [];
  transaction_details.forEach(room=>{
    let same_room = rooms.findIndex(rm=>rm.room_rate_id == room.room_rate_id)
    if(same_room != -1){
      let total_dates = [...rooms[same_room].dates,...room.dates]
      rooms[same_room].qty++
      rooms[same_room].dates = total_dates
    }
    else rooms.push(room)
  })

  rooms.forEach(room => {
    const {
      room_rate_id: item_id,
      room_type: { name: item_name },
      rate: { name: item_variant },
      dates,
      qty
    } = room

    items.push({
      item_id, item_name, item_variant, item_brand,
      quantity: qty,
      price: dates.reduce((sum, val) => val.sub_total + sum, 0),
      item_category: "Room"
    })
  });

  additional_service_details.forEach(product => {
    const { id: item_id, name: item_name, price, qty } = product;
    items.push({
      item_id, item_name, item_brand,
      quantity: qty,
      price: Number(price),
      item_category: "Additional Product"
    })
  })

  tx_merchant_pos.forEach(pos => {
    pos.products.forEach(product => {
      const { id: item_id, name: item_name, variant_name: item_variant, subtotal_sell, qty } = product;
      let item = {
        item_id, item_name, item_brand,
        quantity: qty,
        price: Number(subtotal_sell),
        item_category: "Additional Product"
      }

      if(item_variant) item.item_variant = item_variant

      items.push(item)
    })
  })

  let params = {
    main: {
      transaction_id: order_code,
      value: Number(total_payment),
      currency,
      shipping: 0,
      tax: Number(total_taxes),
      items
    },
    custom: {}
  }

  const isPaylater = status !== 'WAITING_PAYMENT_CONFIRMATION' && payment_details.payment_method_name === null;
  if(isPaylater) params.custom.payment_type = 'Pay at Hotel'
  else if(payment_details) params.custom.payment_type = payment_details.payment_method_name

  if(promo_code) params.main.coupon = promo_code
  if(eventName === 'transaction_cancelled') params.custom.cancellation_reason = cancellation_reason;
  if(eventName === 'payment_pending' && payment_details && payment_details.payment_validation_time){
    const expiredTime = moment(created_at).add(payment_details.payment_validation_time, 'hours');
    params.custom.payment_deadline = expiredTime.toISOString()
  }
  if(eventName === 'purchase' && Vue.prototype.$isNotEmptyV2(rooms)){
    const { check_in_date, check_out_date } = rooms[0]
    params.main.check_in_date = check_in_date
    params.main.check_out_date = check_out_date
  }

  return params
}

const EVENT_STRATEGIES = {
  'page_view': { generator: generatePageViewParams, wrapper: null },
  'search_room': { generator: generateSearchRoomParams, wrapper: null },
  'view_item_list': { generator: generateSearchRoomResultParams, wrapper: 'ecommerce' },
  'view_item': { generator: generateRoomRateDetailParams, wrapper: 'ecommerce' },
  'add_to_cart': { generator: generateAddToCartParams, wrapper: 'ecommerce' },
  'begin_checkout': { generator: generateBeginCheckoutParams, wrapper: 'ecommerce' },
  'add_shipping_info': { generator: generateBeginCheckoutParams, wrapper: 'ecommerce' },
  'add_payment_info': { generator: generateBeginCheckoutParams, wrapper: 'ecommerce' },
  'purchase': { generator: generateTransactionResultParams, wrapper: 'ecommerce' },
  'transaction_cancelled': { generator: generateTransactionResultParams, wrapper: 'ecommerce' },
  'payment_pending': { generator: generateTransactionResultParams, wrapper: 'ecommerce' },
};

export const trackEvent = (eventName, data = {}) => {
  const { google_tag_manager_id = null, google_analytics_id = null, merchant_type = "" } = store.getters.getMerchant;

  const { containerIds, googleTagIds } = classifyTagIds([google_tag_manager_id, google_analytics_id]);
  const hasContainer = containerIds.length > 0;
  const hasGoogleTag = googleTagIds.length > 0;

  if(merchant_type !== 'hotel' || (!hasContainer && !hasGoogleTag)) return;

  const strategy = EVENT_STRATEGIES[eventName];
  if (!strategy) {
    console.warn(`[Analytics] Event '${eventName}' is not handled.`);
    return;
  }

  const trackParams = strategy.generator(data, eventName);

  if(hasContainer){
    const dataLayerPayload = strategy.wrapper
    ? { event: eventName, [strategy.wrapper] : trackParams.main, ...trackParams.custom }
    : { event: eventName, ...trackParams.main, ...trackParams.custom };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerPayload);
  }

  if(hasGoogleTag){
    ensureGtagStub();
    window.gtag('event', eventName, {
      ...trackParams.main,
      ...trackParams.custom
    });
  }
}

let lastToRoute = null
let lastFromRoute = null

export function initRouteTracking (router) {
  router.onReady(() => {
    lastToRoute = router.currentRoute
    lastFromRoute = null
  })

  router.afterEach((to, from) => {
    lastToRoute = to
    lastFromRoute = from
  })
}

export function trackPageViewAfterDataLoaded () {
  if (!lastToRoute) {
    // fallback: first load (no from)
    trackEvent('page_view', {to: Vue.$route || null, from: null})
    return
  }

  trackEvent('page_view', {to: lastToRoute, from:lastFromRoute})
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js